export default __webpack_public_path__ + "static/media/check.48c6ce59.svg";